import { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import CreatorPortal from "./components/portals/creatorPortal";
import OnboardingPortal from "./components/portals/onboardingPortal";
import PatientPortal from "./components/portals/patientPortal";

import constants from "./assets/constants";

// The env check has to stay inline in this ternary so webpack can fold it and drop the import():
// builds without REACT_APP_ENABLE_DESIGN_PORTAL="true" (pre/prod) never ship the design portal.
const CreatorDesignPortal =
  process.env.REACT_APP_ENABLE_DESIGN_PORTAL === "true"
    ? lazy(() => import("./components/portals/creatorDesignPortal"))
    : null;

const getOmniOrganizationPortal = awsGroup => {
  if (awsGroup === constants.userGroups.Creator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathCreator}>
          <CreatorPortal />
        </Route>

        {CreatorDesignPortal && (
          <Route exact path={constants.appPaths.appPathCreatorDesign}>
            <Suspense fallback={null}>
              <CreatorDesignPortal />
            </Suspense>
          </Route>
        )}

        <Route exact path={constants.appPaths.appPathCreatorDemoOnboarding}>
          <OnboardingPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoPatient}>
          <PatientPortal />
        </Route>

        <Route render={() => <Redirect to={constants.appPaths.appPathCreator} />} />
      </Switch>
    );
  }
};

export default getOmniOrganizationPortal;
